/* unplugin-vue-components disabled */import { render } from "./kpiClassifySelect.vue?vue&type=template&id=20ec1774"
import script from "./kpiClassifySelect.vue?vue&type=script&lang=js"
export * from "./kpiClassifySelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__